import { get } from './fetcher';
import { API_ENDPOINTS } from '../config/api-config';

/**
 * 법정동 코드 조회 API
 */

/**
 * addressType 상수
 */
export const ADDRESS_TYPE = {
  SIDO: 1,           // 시도 목록
  SIGUNGU: 2,        // 시군구 목록
  DONG: 3,           // 행정동 목록
  BJDONG: 4,         // 법정동 목록
  DONG_DETAIL: 5,    // 행정동 상세 정보
  BJDONG_DETAIL: 6,  // 법정동 상세 정보
  RI: 7              // 리 목록
};

/**
 * BJD 목록 조회
 * @param {number} addressType - 주소 타입 (1~7)
 * @param {string} addressCode - 상위 코드 (addressType이 1이면 불필요)
 * @returns {Promise<Array>} BJD 목록
 */
export const getBjdList = async (addressType, addressCode = null) => {
  const params = {
    addressType,
  };

  if (addressCode) {
    params.addressCode = addressCode;
  }

  return get(API_ENDPOINTS.SYSTEM.BJD_LIST, params);
};

export const getBjdTree = async () => {
  return get(API_ENDPOINTS.SYSTEM.BJD_TREE);
};

export const getRankerBjdTree = async (params = {}) => {
  return get(API_ENDPOINTS.SYSTEM.RANKER_BJD_TREE, params);
};

/**
 * 시도 목록 조회
 * @returns {Promise<Array>} 시도 목록
 */
export const getSidoList = async () => {
  return getBjdList(ADDRESS_TYPE.SIDO);
};

/**
 * 시군구 목록 조회
 * @param {string} sidoCode - 시도 코드 (10자리, 예: 1100000000)
 * @returns {Promise<Array>} 시군구 목록
 */
export const getSigunguList = async (sidoCode) => {
  return getBjdList(ADDRESS_TYPE.SIGUNGU, sidoCode);
};

/**
 * 행정동 목록 조회
 * @param {string} sigunguCode - 시군구 코드 (10자리, 예: 1168000000)
 * @returns {Promise<Array>} 행정동 목록
 */
export const getDongList = async (sigunguCode) => {
  return getBjdList(ADDRESS_TYPE.DONG, sigunguCode);
};

/**
 * 법정동 목록 조회
 * @param {string} sigunguCode - 시군구 코드 (10자리, 예: 1168000000)
 * @returns {Promise<Array>} 법정동 목록
 */
export const getBjdongList = async (sigunguCode) => {
  return getBjdList(ADDRESS_TYPE.BJDONG, sigunguCode);
};

/**
 * 행정동 상세 정보 조회
 * @param {string} dongCode - 행정동 코드 (10자리, 예: 1168010100)
 * @returns {Promise<Array>} 행정동 상세 정보
 */
export const getDongDetail = async (dongCode) => {
  return getBjdList(ADDRESS_TYPE.DONG_DETAIL, dongCode);
};

/**
 * 법정동 상세 정보 조회
 * @param {string} bjdongCode - 법정동 코드 (10자리, 예: 1168010100)
 * @returns {Promise<Array>} 법정동 상세 정보
 */
export const getBjdongDetail = async (bjdongCode) => {
  return getBjdList(ADDRESS_TYPE.BJDONG_DETAIL, bjdongCode);
};

/**
 * 리 목록 조회
 * @param {string} eubMyeonCode - 읍면 코드
 * @returns {Promise<Array>} 리 목록
 */
export const getRiList = async (eubMyeonCode) => {
  return getBjdList(ADDRESS_TYPE.RI, eubMyeonCode);
};
